<template>
  <Field class="form-field" as="fieldset" :width="width">
    <legend v-if="label" class="text-base font-medium text-gray-900">
      {{ label }}
    </legend>
    <p v-if="text" class="text-sm leading-5 text-gray-500">
      {{ text }}
    </p>
    <div class="space-y-4 mt-4">
      <slot name="default" />
      <Option
        v-for="(option, key) in options"
        v-model="selected"
        v-bind="option"
        :class="{ error }"
        :key="key"
        :name="name || option.name"
        :type="type"
        :value="typeof option.value === 'undefined' ? key : option.value"
        @change="$emit('update:modelValue', selected)"
      />
    </div>
    <div v-if="error" class="form-error">
      {{ error }}
    </div>
  </Field>
</template>

<script>
import Field from 'Web/Form/Fields/Field.vue';
import Option from 'Web/Form/Inputs/Option.vue';
import { ref, watchEffect } from 'vue';

export default {
  inheritAttrs: false,
  emits: [
    'update:modelValue',
  ],
  components: {
    Field,
    Option,
  },
  props: {
    error: String,
    label: String,
    modelValue: null,
    name: String,
    options: {
      type: [Array, Object],
      default: () => [],
    },
    text: String,
    type: {
      type: String,
      required: true,
    },
    width: String,
  },
  setup(props) {
    const selected = ref();

    function defaultValue() {
      return props.type === 'checkbox' ? [] : null;
    }

    watchEffect(() => selected.value = props.modelValue ?? defaultValue());

    return {
      selected,
    }
  }
}
</script>
